import { useMemo } from "react";

import { useGetScorecards } from "@/hooks/useGetScorecards/useGetScorecards";
import { UseGetScorecardByIDArgs } from "./useGetScorecardByID.decl";

export function useGetScorecardByID({ ID }: UseGetScorecardByIDArgs) {
  const { loading, scorecards } = useGetScorecards({ ID, limit: 1 });

  const sortedScorecard = useMemo(() => {
    const firstScorecard = scorecards?.[0];

    if (!firstScorecard) {
      return null;
    }

    /**
     * We sort categories and questions by `order`
     */
    const sortedCategoriesAndQuestions = firstScorecard.categories
      .map((category) => ({
        ...category,
        questions: [...category.questions].sort((a, b) => a.order - b.order),
      }))
      .sort((a, b) => a.order - b.order);

    return {
      ...firstScorecard,
      categories: sortedCategoriesAndQuestions,
    };
  }, [scorecards]);

  return { loading, scorecard: sortedScorecard };
}
